import script from "./CustomStepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomStepper.vue?vue&type=script&setup=true&lang=ts"

import "./CustomStepper.vue?vue&type=style&index=0&id=0880b56f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0880b56f"]])

export default __exports__